export const getDocument = (): Document | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return document;
};
